import { Typography, theme } from "antd";
import { DefaultButton } from "components/Shared/DefaultButton";
import { DefaultModal } from "components/Shared/DefaultModal";
import { useDeleteFixtureTask } from "hooks/useFixtureTaskApi";
import { useDeleteSeasonTask } from "hooks/useSeasonTaskApi";
import { useState } from "react";
import { useIntl } from "react-intl";

const { useToken } = theme;

type Props = {
  entityId: string;
  seasonId: string;
  fixtureId?: string;
};

export const DeleteTaskButton: React.FC<Props> = ({ entityId, seasonId, fixtureId }: Props) => {
  const { formatMessage } = useIntl();
  const { token } = useToken();
  const [openModal, setOpenModal] = useState(false);
  const { mutateAsync: deleteSeasonTask, isPending: isSeasonTaskDeleting } = useDeleteSeasonTask();
  const { mutateAsync: deleteFixtureTask, isPending: isFixtureTaskDeleting } = useDeleteFixtureTask();

  const onDelete = async () => {
    try {
      if (fixtureId) {
        await deleteFixtureTask({ entityId, seasonId, fixtureId });
      } else {
        await deleteSeasonTask({ entityId, seasonId });
      }
    } finally {
      setOpenModal(false);
    }
  };

  return (
    <>
      <DefaultButton type="text" onClick={() => setOpenModal(true)} icon={<i className="fa-solid fa-trash-can" />}>
        <Typography.Text strong style={{ color: token.colorPrimary }} className="text-upper">
          {formatMessage({ id: "button.delete" })}
        </Typography.Text>
      </DefaultButton>
      {openModal && (
        <DefaultModal
          open={openModal}
          onCancel={() => setOpenModal(false)}
          onOk={onDelete}
          okText={formatMessage({ id: "button.delete" })}
          okButtonProps={{
            loading: isSeasonTaskDeleting || isFixtureTaskDeleting,
          }}
          cancelButtonProps={{
            disabled: isSeasonTaskDeleting || isFixtureTaskDeleting,
          }}
          width={undefined}
          title={formatMessage({ id: "deleteTaskConfirmationModal.title" })}
        >
          <Typography.Text>{formatMessage({ id: "deleteTaskConfirmationModal.content" })}</Typography.Text>
        </DefaultModal>
      )}
    </>
  );
};
